import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { Page, PageHead } from "@/components/hub/Common";
import { ReleaseCard } from "@/components/hub/ReleaseCard";

export default function Releases() {
  const { t, lang } = useI18n();
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/releases").then((r) => setList(r.data)).catch(() => setList([])); }, [lang]);
  const current = list?.[0]?.version;
  return (
    <Page>
      <PageHead label={t("rel.label")} t1={t("rel.title1")} t2={t("rel.title2")} sub={t("rel.sub")}
        right={current && (
          <div className="cx-card cx-brackets rounded-xl px-6 py-4" data-testid="current-version">
            <div className="cx-label">{t("rel.current")}</div>
            <div className="font-display font-bold text-3xl text-white mt-1">V{current}</div>
          </div>
        )} />
      <div className="relative mt-10 max-w-4xl">
        <div className="absolute left-3 top-2 bottom-2 w-px bg-gradient-to-b from-[#2f7bff] via-[#a746ff]/50 to-transparent hidden sm:block" />
        <div className="space-y-8 sm:pl-12" data-testid="releases-list">
          {list?.length === 0 && <p className="text-slate-500" data-testid="releases-empty">{t("rel.empty")}</p>}
          {list?.map((r, i) => (
            <div key={r.id} className="relative cx-rise" style={{ animationDelay: `${i * 0.06}s` }}>
              <span className="hidden sm:block absolute -left-[45px] top-9 w-3.5 h-3.5 rounded-full bg-[#3ad7ff] shadow-[0_0_16px_#3ad7ff]" />
              <ReleaseCard r={r} latest={i === 0} />
            </div>
          ))}
        </div>
      </div>
    </Page>
  );
}
